"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HEADSPACE_GLOBAL_ENVIRONMENT_KEY = 'HEADSPACE_APP_CONFIG';

function getHeadspaceGlobalEnvironment() {
  return typeof window !== 'undefined' ? window[HEADSPACE_GLOBAL_ENVIRONMENT_KEY] : typeof global !== 'undefined' ? global[HEADSPACE_GLOBAL_ENVIRONMENT_KEY] : {};
}

exports.getHeadspaceGlobalEnvironment = getHeadspaceGlobalEnvironment;

function setHeadspaceGlobalEnvironment(environment) {
  if (typeof window !== 'undefined') {
    window[HEADSPACE_GLOBAL_ENVIRONMENT_KEY] = environment;
  } else if (typeof global !== 'undefined') {
    global[HEADSPACE_GLOBAL_ENVIRONMENT_KEY] = environment;
  }
}

exports.setHeadspaceGlobalEnvironment = setHeadspaceGlobalEnvironment;